var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.85417 12.971C9.22236 12.971 9.52083 12.6726 9.52083 12.3044C9.52083 11.9362 9.22236 11.6377 8.85417 11.6377C8.48598 11.6377 8.1875 11.9362 8.1875 12.3044C8.1875 12.6726 8.48598 12.971 8.85417 12.971Z",
    fill: "#DDDEE0",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85417 8.97103C9.22236 8.97103 9.52083 8.67255 9.52083 8.30436C9.52083 7.93617 9.22236 7.6377 8.85417 7.6377C8.48598 7.6377 8.1875 7.93617 8.1875 8.30436C8.1875 8.67255 8.48598 8.97103 8.85417 8.97103Z",
    fill: "#DDDEE0",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85417 4.97103C9.22236 4.97103 9.52083 4.67255 9.52083 4.30436C9.52083 3.93617 9.22236 3.6377 8.85417 3.6377C8.48598 3.6377 8.1875 3.93617 8.1875 4.30436C8.1875 4.67255 8.48598 4.97103 8.85417 4.97103Z",
    fill: "#DDDEE0",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/more_options.84c44cb6bce0cb18e5f108f65c8270ed.svg";
export { ForwardRef as ReactComponent };